import Vue from 'vue';
import VueRouter from 'vue-router';

import Layout from '@/layout';
import cookies from 'vue-cookies'
import { Message, MessageBox } from 'element-ui';
import { checkIUGT } from '@/api/home.js';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    component: Layout,
    // redirect: 'main',
    children: [{
      path: 'hold',
      name: 'Hold',
      meta: {
        title: '预约'
      },
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import('../views/hold/index.vue'),
    }, {
      path: 'hold-list',
      name: 'HoldList',
      meta: {
        title: '我的预约'
      },
      component: () => import('../views/hold-list/index.vue'),
    }, {
      path: 'main',
      name: 'main',
      meta: {
        title: '个人中心'
      },
      component: () => import('../views/main/index.vue'),
    }, {
      path: 'loan',
      name: 'loan',
      meta: {
        title: '我的借阅'
      },
      component: () => import('../views/loan/index.vue'),
    }, {
      path: 'loan-history',
      name: 'loan-history',
      meta: {
        title: '借阅历史'
      },
      component: () => import('../views/loan-history/index.vue'),
    }, {
      path: 'loan-rules',
      name: 'loan-rules',
      meta: {
        title: '借阅规则'
      },
      component: () => import('../views/loan-rules/index.vue'),
    }, {
      path: 'savings',
      name: 'savings',
      meta: {
        title: '我的收藏'
      },
      component: () => import('../views/savings/index.vue'),
    }, {
      path: 'info',
      name: 'info',
      meta: {
        title: '个人信息'
      },
      component: () => import('../views/info/index.vue'),
    }, {
      path: 'ai',
      name: 'ai',
      meta: {
        title: 'AI应用创意案例征集大赛'
      },
      component: () => import('../views/ai/index.vue'),
    }]
  }
];

const router = new VueRouter({
  mode: 'history',
  base: '/portal/',
  routes,
});

/**
router.beforeEach(async (to, from, next) => {
  document.title = `${to.meta.title} -北京大学图书馆`;
  next();
});
**/

router.beforeEach(async (to, from, next) => {
  document.title = `${to.meta.title} -北京大学图书馆`;
  if(to.meta.title == undefined){
    document.title = `个人中心 -北京大学图书馆`;
  }
  var oneStopWebToken = to.query.code;
  const fromParam = to.query.from;
// AI案例大赛投票路由处理
//  if(fromParam === "aivote"){
//    // window.location.replace('https://sso.lib.pku.edu.cn/oauth/authorize?client_id=oneStopWebTest&redirect_uri=https://atest.lib.pku.edu.cn:8443/sso/login&response_type=code&state=aivote&from=aivote');
//    // 等AI投票页面上线再打开下面这行
//    window.location.replace('https://sso.lib.pku.edu.cn/oauth/authorize?client_id=oneStopWeb&redirect_uri=https://a.lib.pku.edu.cn:8443/sso/login&response_type=code&state=aivote&from=aivote');
//    return;
//  }
 // pabr2025路由处理
  if(fromParam === "pabr2025"){
    window.location.replace('https://sso.lib.pku.edu.cn/oauth/authorize?client_id=oneStopWeb&redirect_uri=https://a.lib.pku.edu.cn:8443/sso/login&response_type=code&state=pabr2025&from=pabr2025');
    return;
  }
  if (to.hash == "#edit-phone") {
    if (!cookies.get('code')) {
      const response = await checkIUGT();
      if (response) {
        cookies.set('code', response, { path: '/', domain: 'lib.pku.edu.cn' });
        // window.location.replace('https://atest.lib.pku.edu.cn/portal/main'+ to.hash);
        window.location.replace('https://a.lib.pku.edu.cn/portal/main'+ to.hash);
      }
    }else{
      // window.location.replace('https://atest.lib.pku.edu.cn/portal/main'+ to.hash);
      window.location.replace('https://a.lib.pku.edu.cn/portal/main'+ to.hash);
    }
  }
  if(to.path == "/ai" || to.path == "/loan" || to.path == "/hold-list" || to.path == "/loan-rules"  || to.path == "/loan-history" || to.path == "/savings"){
   cookies.set('flag', to.path, { path: '/', domain: 'lib.pku.edu.cn' });
  }
  if(cookies.get('code') && to.path != "/"){
    if(oneStopWebToken != null){
      cookies.set('code', oneStopWebToken, { path: '/', domain: 'lib.pku.edu.cn' });
    }
    next();
  } else if(cookies.get('code') && to.path == "/"){
    // window.location.replace('https://sso.lib.pku.edu.cn/oauth/authorize?client_id=oneStopWebTest&redirect_uri=https://atest.lib.pku.edu.cn:8443/sso/login&response_type=code&state=PCReaderOAuth&destination='+ to.fullPath);
    window.location.replace('https://sso.lib.pku.edu.cn/oauth/authorize?client_id=oneStopWeb&redirect_uri=https://a.lib.pku.edu.cn:8443/sso/login&response_type=code&state=PCReaderOAuth');
  } else if(oneStopWebToken && to.path == "/main"){
    cookies.set('code', oneStopWebToken, { path: '/', domain: 'lib.pku.edu.cn' });
    next({
      path: '/main',
      query: {}
    });
    if(cookies.get('flag') == "/ai"){
        window.location.replace('https://a.lib.pku.edu.cn/portal/ai');
    }
    if(cookies.get('flag') == "/loan"){
        window.location.replace('https://a.lib.pku.edu.cn/portal/loan');
    }
    if(cookies.get('flag') == "/hold-list"){
        window.location.replace('https://a.lib.pku.edu.cn/portal/hold-list');
    }
    if(cookies.get('flag') == "/loan-rules"){
        window.location.replace('https://a.lib.pku.edu.cn/portal/loan-rules');
    }
    if(cookies.get('flag') == "/savings"){
        window.location.replace('https://a.lib.pku.edu.cn/portal/savings');
    }
    if(cookies.get('flag') == "/loan-history"){
        window.location.replace('https://a.lib.pku.edu.cn/portal/loan-history');
    }
  } else {
    document.title = `个人中心 -北京大学图书馆`;
    // window.location.replace('https://sso.lib.pku.edu.cn/oauth/authorize?client_id=oneStopWebTest&redirect_uri=https://atest.lib.pku.edu.cn:8443/sso/login&response_type=code&state=PCReaderOAuth&destination='+ to.fullPath);
    window.location.replace('https://sso.lib.pku.edu.cn/oauth/authorize?client_id=oneStopWeb&redirect_uri=https://a.lib.pku.edu.cn:8443/sso/login&response_type=code&state=PCReaderOAuth');
  }
});

router.afterEach(() => {
  window.scrollTo(0, 0);
});

export default router;
